<div class="row m-0 pt-5">
	<div class="col-lg-12">
		<div class="pl-3 pr-3 mt-4">
			<span class="py-3">Notification Area</span>
		</div>

		<mat-card class="card-top my-3 d-flex justify-content-between">
			<span>Notifications</span>
			<span *ngIf="notifications && notifications.unreads > 0">
				{{ notifications.unreads }} New
				<span *ngIf="notifications.unreads === 1">item</span>
				<span *ngIf="notifications.unreads > 1">items</span>
			</span>
		</mat-card>

		<ng-container *ngIf="notificationsList && notificationsList.length">
			<ng-container *ngFor="let item of notificationsList; let i = index">
				<!-- change STATUS to item.status -->
				<app-notification
					[status]="item.status"
					[item]="item"
					[length]="notificationsList.length - i"
				></app-notification>
			</ng-container>
		</ng-container>
		<ng-container *ngIf="!notificationsList || notificationsList.length < 1">
			<div class="pl-3 pr-3 mt-4">
				<span class="py-3">Notification Area</span>
			</div>
		</ng-container>
	</div>
</div>
